import { combineReducers } from 'redux';
import migrationSettings from './MigrationSettingsReducer';
import migrationProcess from './MigrationProcessReducer';
import reviewDataCuts from './ReviewDataCutsReducer';

const surveyMigration = combineReducers({
  migrationSettings,
  migrationProcess,
  reviewDataCuts
});

export default surveyMigration;
